import _mergeJSXProps2 from "@vue/babel-helper-vue-jsx-merge-props";
import _mergeJSXProps from "@vue/babel-helper-vue-jsx-merge-props";
var __decorate = this && this.__decorate || function (decorators, target, key, desc) {
  var c = arguments.length,
    r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
    d;
  if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { has } from "lodash-es";
import { Component, Inject, Prop, Vue, Watch } from 'vue-property-decorator';
import { vueComponentMixin } from '@tencent/data-schema/lib/vue-ui/definitions';
import ExprInput from '../ExprInput';
import { INJECT_UICORE_DESIGNER } from "../../../../lib/utils/consts";
import * as s from "./MethodArgumentsInput.module.css";
import Markdown from '../../components/Markdown';
import makeSchmittTrigger from "../../../../lib/utils/makeSchmittTrigger";
import FloatPortal from "../../../../lib/comps/Portal/FloatPortal";
import { generateMethodDocumentMarkdown } from "../../../../lib/utils/dataSchema/generateMethodDocumentMarkdown";
import { getTitleWithParentheses } from "../../../../lib/utils/string";
const listenerRootClass = 'uc_mai_listener_root_el';
let MethodArgumentsInput = class MethodArgumentsInput extends Vue {
  fixEditValue() {
    if (!Array.isArray(this.editValue)) this.editValue = [];
  }
  get currentMethod() {
    return this.getMethodSchema.call(this, this);
  }
  modifyArray(fn) {
    const ans = [...this.editValue];
    fn(ans);
    this.editValue = ans;
  }
  updateArrayItem(index, value) {
    this.modifyArray(arr => {
      while (arr.length <= index) arr.push('');
      // eslint-disable-next-line no-param-reassign
      arr[index] = value;
    });
  }
  getManualShownHander(isShow) {
    return e => {
      var _el$classList;
      const el = e.target;
      if (el !== null && el !== void 0 && (_el$classList = el.classList) !== null && _el$classList !== void 0 && _el$classList.contains(listenerRootClass)) {
        this.manualShown = isShow;
      }
    };
  }
  get captureManualListeners() {
    const show = this.getManualShownHander(true);
    const hide = this.getManualShownHander(false);
    return {
      '!focus': show,
      '!blur': hide,
      '!mouseenter': show,
      '!mouseleave': hide
    };
  }
  get markdownSource() {
    return generateMethodDocumentMarkdown(this.currentMethod);
  }
  get manualVNode() {
    const h = this.$createElement;
    if (!this.showDoc) return null;
    if (!this.manualShown) return null;
    if (!this.currentMethod) return null;
    return h(FloatPortal, {
      "class": s.manualBoxAnchor
    }, [h("div", _mergeJSXProps([{
      "class": [s.manualBox, listenerRootClass]
    }, {
      "on": this.captureManualListeners
    }]), [h("markdown", {
      "attrs": {
        "source": this.markdownSource,
        "openInNewWindow": true
      }
    })])]);
  }
  get helpTooltipIcons() {
    var _this$currentMethod;
    const h = this.$createElement;
    const methodArgs = (_this$currentMethod = this.currentMethod) === null || _this$currentMethod === void 0 ? void 0 : _this$currentMethod.arguments;
    if (!methodArgs) return [];
    return methodArgs.map(arg => [arg.required === false && h("div", {
      "class": s.itemTitleIndex
    }, ['[可选]']), arg.title, !!arg.description && h("a-tooltip", {
      "attrs": {
        "overlayClassName": s.mkTooltip
      }
    }, [h("markdown", {
      "slot": "title",
      "attrs": {
        "source": arg.description,
        "openInNewWindow": true
      }
    }), h("a-icon", {
      "attrs": {
        "type": "info-circle"
      },
      "class": "w-formItem-label-tooltip"
    })])]);
  }
  get genDefaultBtns() {
    var _this$currentMethod2;
    const h = this.$createElement;
    const methodArgs = (_this$currentMethod2 = this.currentMethod) === null || _this$currentMethod2 === void 0 ? void 0 : _this$currentMethod2.arguments;
    if (!methodArgs) return [];
    return methodArgs.map((arg, index) => {
      if (!has(arg, 'default')) {
        return null;
      }
      return h("a-button", {
        "attrs": {
          "size": "small"
        },
        "class": s.defaultBtn,
        "on": {
          "click": () => {
            this.$set(this.editValue, index, String(arg.default));
          }
        }
      }, ["\u751F\u6210\u9ED8\u8BA4\u53C2\u6570"]);
    });
  }
  renderParamLabel(index) {
    var _this$currentMethod3, _methodArgs$index, _methodArgs$index2;
    const h = this.$createElement;
    const methodArgs = (_this$currentMethod3 = this.currentMethod) === null || _this$currentMethod3 === void 0 ? void 0 : _this$currentMethod3.arguments;
    const text = methodArgs && (_methodArgs$index = methodArgs[index]) !== null && _methodArgs$index !== void 0 && _methodArgs$index.id ? (_methodArgs$index2 = methodArgs[index]) === null || _methodArgs$index2 === void 0 ? void 0 : _methodArgs$index2.id : `参数${index + 1}`;
    return h("div", {
      "class": s.itemTitleIndex
    }, [`[${text}]`]);
  }
  render() {
    var _this$currentMethod4;
    const h = arguments[0];
    return h("div", _mergeJSXProps2([{
      "class": [s.list, listenerRootClass]
    }, {
      "on": this.captureManualListeners
    }]), [this.manualVNode, Array.from({
      length: Math.max(this.editValue.length, ((_this$currentMethod4 = this.currentMethod) === null || _this$currentMethod4 === void 0 || (_this$currentMethod4 = _this$currentMethod4.arguments) === null || _this$currentMethod4 === void 0 ? void 0 : _this$currentMethod4.length) || 0)
    }, (_, index) => h("div", {
      "key": index
    }, [h("div", {
      "class": s.itemTitle
    }, [this.showAddArg && index < this.editValue.length && h("div", {
      "class": s.itemTitleActions
    }, [h("i", {
      "class": `fa fa-plus ${s.itemAction}`,
      "attrs": {
        "title": "在前面插入"
      },
      "on": {
        "click": () => this.modifyArray(arr => arr.splice(index, 0, ''))
      }
    }), h("i", {
      "class": `fa fa-trash ${s.itemAction}`,
      "attrs": {
        "title": "删除"
      },
      "on": {
        "click": () => this.modifyArray(arr => arr.splice(index, 1))
      }
    })]), this.renderParamLabel(index), this.helpTooltipIcons[index]]), this.genDefaultBtns[index], h(ExprInput, {
      "attrs": {
        "guide-el": `method-arg-index-${index}`,
        "value": this.editValue[index] || '',
        "dataStub": this.dataStub
      },
      "on": {
        "change": value => this.updateArrayItem(index, value)
      }
    })])), this.showAddArg && h("div", [h("button", {
      "class": "uc-button",
      "attrs": {
        "type": "button"
      },
      "on": {
        "click": () => this.modifyArray(arr => arr.push(''))
      }
    }, [h("i", {
      "class": "fa fa-plus"
    }), ' 添加参数'])]), this.showDoc && this.currentMethod && this.markdownSource && h("div", [h("button", {
      "class": "uc-button isBorderless",
      "attrs": {
        "type": "button"
      }
    }, [h("i", {
      "class": "fa fa-book"
    }), getTitleWithParentheses(this.currentMethod.id, this.currentMethod.title), " \u7684\u6587\u6863"])])]);
  }
};
__decorate([Prop(Function)], MethodArgumentsInput.prototype, "getMethodSchema", void 0);
__decorate([Prop({
  default: true
})], MethodArgumentsInput.prototype, "showDoc", void 0);
__decorate([Prop({
  default: true
})], MethodArgumentsInput.prototype, "showAddArg", void 0);
__decorate([Prop()], MethodArgumentsInput.prototype, "dataStub", void 0);
__decorate([Inject({
  from: INJECT_UICORE_DESIGNER,
  default: null
})], MethodArgumentsInput.prototype, "designer", void 0);
__decorate([Watch('editValue', {
  immediate: true
})], MethodArgumentsInput.prototype, "fixEditValue", null);
MethodArgumentsInput = __decorate([Component({
  name: 'MethodArgumentsInput',
  mixins: [vueComponentMixin],
  components: {
    Markdown
  },
  data() {
    return {
      internalManualShown: false
    };
  },
  computed: {
    manualShown: makeSchmittTrigger('internalManualShown', 250)
  }
})], MethodArgumentsInput);
export default MethodArgumentsInput;
//# sourceMappingURL=index.js.map
